import PropTypes from 'prop-types';
import React from 'react';

class NoRoleHome extends React.Component {

  render() {
    return (
      <div className="container">
        <div className="panel">
          <h1>Welcome to Use Catch!</h1>
          <div>Thanks for visting. Nothing to see here now.</div>
          <div><a href="mailto:info@usecatch.com">Contact us</a> if you need access to a tour or travel agency?</div>
        </div>
      </div>
    );
  }
}

export default NoRoleHome;



// WEBPACK FOOTER //
// src/routes/home/components/NoRoleHome.js